import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Block } from '../model/block';
import { AngularFireList, AngularFireObject } from '@angular/fire/compat/database';
import { from } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class BlockService {
  pageArray = [];
  pageRef: AngularFireObject<any>;

  constructor(private db: AngularFirestore, private alertController: AlertController) {

  }

  loadLiveList() {
    return this.db.collection('blocks', (ref) => ref.orderBy('title'));
  }


  getBlock(id: string) {
    return this.db.collection('blocks').doc(id).snapshotChanges();
  }


  createBlock(blocks: Block) {
    return this.db.collection('blocks').add({
      title: blocks.title,
      codeword: blocks.codeword,
      body: blocks.body,
      timestamp: blocks.timestamp,
    });
  }

  updateBlock(id: string, blocks: Partial<Block>) {
    return from(this.db.doc(`blocks/${id}`).update(blocks));
  }

  async deleteBlock(id){
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Delete This Block',
      message: 'Are You Sure?',
      mode: 'ios',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Okay',
          handler: () => {
            this.db.collection('blocks').doc(id).delete();
          }
        }
      ]
    });

    return await alert.present();
  }



}
